// this function is exported from it's own file so it can be spied on in tests
export const listReportRequestsHandleStopPolling = (stopPolling: () => void) => stopPolling()
